(function($) {
	$(document).foundation();
	//$("#navigation").sticky({topSpacing:0});
	$('.owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    nav:false,
		dots: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
	});
	$('body').fitVids();

	$(window).scroll(function() {
	if ($(this).scrollTop() > 120){
			$("#navigation").addClass('is-sticky');
	  }
	  else{
			$("#navigation").removeClass('is-sticky');
	  }
	});

	$('a[href*="#"]:not([href="#"])').click(function() {
	 if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
		 var target = $(this.hash);
		 target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		 if (target.length) {
			 $('html, body').animate({
				 scrollTop: target.offset().top - 80
			 }, 1000);
			 return false;
		 }
	 }
 });

})(jQuery);
